(() => {
  if (window.ReneoraCollectionTouchPreview) return;
  window.ReneoraCollectionTouchPreview = true;

  let startX = 0;
  let startY = 0;
  let activeMedia = null;
  let clearTimer = 0;

  document.addEventListener('touchstart', (event) => {
    activeMedia = event.target.closest?.('.rn-product-card__media.has-secondary-image') || null;
    if (event.touches.length !== 1) activeMedia = null;
    if (!activeMedia) return;
    clearTimeout(clearTimer);
    activeMedia.classList.remove('is-touch-preview');
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!activeMedia || event.touches.length !== 1) return;
    const distance = Math.hypot(event.touches[0].clientX - startX, event.touches[0].clientY - startY);
    if (distance > 8) activeMedia.classList.add('is-touch-preview');
  }, { passive: true });

  const finishTouch = () => {
    const media = activeMedia;
    activeMedia = null;
    if (!media) return;
    clearTimer = window.setTimeout(() => media.classList.remove('is-touch-preview'), 650);
  };
  document.addEventListener('touchend', finishTouch, { passive: true });
  document.addEventListener('touchcancel', finishTouch, { passive: true });
})();
